export default "__VITE_ASSET__c8KmpAHm__"